import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-aquatech-digital-twin',
  imports: [RouterModule],
  templateUrl: './aquatech-digital-twin.component.html',
  styleUrl: './aquatech-digital-twin.component.scss',
  encapsulation: ViewEncapsulation.None 
})
export class AquatechDigitalTwinComponent implements OnInit {
  constructor(private meta: Meta, private title: Title) {}

  ngOnInit(): void {
    this.title.setTitle(
      'Aquatech Digital Twin | Smart Water Management Platform'
    );

    this.meta.addTags([
      {
        name: 'description',
        content:
          'Explore Aquatech Digital Twin – a smart, data-driven water management platform that provides real-time monitoring, simulation, and optimization of water systems.',
      },
      {
        name: 'keywords',
        content:
          'Aquatech, Digital Twin, water management, smart technology, IoT, simulation, real-time monitoring',
      },
      { name: 'robots', content: 'index, follow' },
    ]);
  }

  getStart() {
    const plansSection = document.getElementById('get-start');
    if (plansSection) {
      plansSection.scrollIntoView({ behavior: 'smooth' });
    }
  }
}
